/* eslint-disable camelcase */
import { GTAG_ID } from 'settings';
import store from 'store';

export enum enFeatures {
  ORDER_BUMP = 'order_bump'
}

const ID_TAG_HTML = 'GTAG_SCRIPT_HTML';
const ID_SCRIPT_GTAG = 'GTAG_HEAD';

export class AnalyticsG4 {
  private inited = {
    scriptInPage: false,
    scriptInitGtag: false
  };
  private eventBuffer: any[] = [];

  public constructor() {
    this.loadScript();
  }

  public config() {
    const { belt, user_id } = this.getUser();

    this.sendGtag('js', new Date());
    this.sendGtag('set', 'send_page_view', false);

    this.sendGtag('config', GTAG_ID, {
      send_page_view: false,
      user_id,
      user_properties: {
        belt
      },
      custom_map: { belt }
    });
  }

  public sendSuccess(feature?: enFeatures) {
    this.sendEvent('success', feature);
  }

  public sendPageView(data: { title?: string; feature?: enFeatures }) {
    const properties = {
      ...(!!data?.title ? { page_title: data?.title } : {})
    };

    this.sendEvent('page_view', data?.feature, {
      ...properties
    });
  }

  private getUser() {
    const { id: user_id, belt } = store.getState().user;

    return {
      user_id,
      belt: belt || 'White Belt'
    };
  }

  private sendEvent(event: 'page_view' | 'success' | 'error', feature?: enFeatures, properties?: object) {
    let feat: { content_group?: string; feature?: string } = {};
    if (!!feature) {
      feat = event === 'page_view' ? { content_group: feature } : { feature };
    }

    const data = {
      ...feat,
      ...properties,
      ...this.getUser()
    };

    this.sendGtag('event', event, data);
  }

  private loadScript() {
    const src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;

    const callback = () => {
      this.inited.scriptInPage = true;
      this.initGtag();
    };

    this.renderScriptInHead(ID_TAG_HTML, callback, src, '');
  }

  private initGtag() {
    const scriptToInject = `
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    window.gtag = gtag;`;

    const callback = () => {
      this.inited.scriptInitGtag = true;
      this.loadBuffer();
    };

    this.renderScriptInHead(ID_SCRIPT_GTAG, callback, '', scriptToInject);
  }

  private renderScriptInHead(id: string, callback: () => void, src?: string, html?: string) {
    if (document.getElementById(id)) {
      callback();
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.id = id;

    if (src) {
      script.src = src;
      script.onload = () => {
        callback();
      };
    }

    if (html) {
      script.innerHTML = html;
    }

    document.head.appendChild(script);
    if (html) {
      callback();
    }
  }

  private loadBuffer() {
    for (const buffer of this.eventBuffer) {
      this.sendGtag(buffer.property, ...buffer.params);
    }
  }

  private sendGtag(property: string, ...params: any) {
    if (!this.inited.scriptInPage || !this.inited.scriptInitGtag) {
      this.eventBuffer.push({ property, params });
      return;
    }

    params.unshift(property);
    window.gtag(...params);
  }
}

export const analyticsG4 = new AnalyticsG4();
